import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { DconConfigAPI } from "../config/config";
import { DataService } from '../config/data.service';

@Injectable({
  providedIn: "root",
})
export class CommonServicesService {

  options: any;
  instanceName: string;
  configType: string = 'load';
  tabval = new BehaviorSubject('select');
  batchKey: string = null;
  authorizationData: any;
  projId: string;
  instanceList: string;
  configObj: any;

  batchKeyDetails: any;
  fromTable: boolean = false;
  Base_Url = this._data.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;

  private monitoring = {
    pendingRequestsNumber: 0,
  };

  constructor(private _https: HttpClient, private _data: DataService) {
    this.authorizationData = this._data.ordstAuthData;
  }

  callDconSecurityCredApi(loader: boolean = true) {
    this.monitoring.pendingRequestsNumber++;
    return this._https.get(
      DconConfigAPI.KEYVAULT_API_URL +
      DconConfigAPI.DCON_SECURITY_CREDENTIALS
    );
  }

  // callUserPermAuthApi(param, options, loader: boolean = true) {
  //   // this.monitoring.pendingRequestsNumber++;
  //   // return this._https.post(
  //   //   param + "dfteworkbench/oauth/token?" + DconConfigAPI.UI_GRANT_TYPE,
  //   //   {},
  //   //   options
  //   // );
  // }

  callUserPermissionApi(secretName) {
    return this._https.get(
     DconConfigAPI.KEYVAULT_API_URL +
     secretName
    );
  }

  // callUipathVaultUrl(projectName) {

  //   // return this._https.get(
  //   //   DconConfigAPI.KEYVAULT_API_URL +
  //   //   projectName +
  //   //   DconConfigAPI.DCON_UIPATH_CREDENTIALS
  //   // );
    
  // }
  callUiPathAuthApi(): Observable<any> {
    const headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
    });

    // Prepare the URL-encoded body
    const body = new URLSearchParams();
    body.set("client_id", DconConfigAPI.UI_PATH_CLIENT_ID);
    body.set("client_secret", DconConfigAPI.UI_PATH_CLIENT_SECRET);
    body.set("scope", "OR.Default");
    body.set("grant_type", "client_credentials");

    // Log the request body for debugging
    console.log('authentication token body', body.toString());

    // Send the POST request and return the observable
    // return this._https.post(DconConfigAPI.UI_PATH_AUTH_URL, body.toString(), { headers });
    return this._https.get(DconConfigAPI.NODE_URL + '/uipath/get-uipath-token');
}

  // callUiPathAuthApi(body) {
  //   return this._https.post(DconConfigAPI.UI_PATH + "/api/account/authenticate", body);
  // }

  callOrdsUrlAssetFetch(payload) {
    console.log('payload', payload)
    return this._https.post(DconConfigAPI.NODE_URL+ '/uipath/get-project-info', payload );
  }

  // **********************************************
  // Commented to use in future requirements
  // **********************************************

  // callFileShareAssetFetch(options) {
  //   return this._https.get(
  //     DconConfigAPI.UIPATH_ASSET_FETCH +
  //     "'" +
  //     DconConfigAPI.CONFIGHUB_WINDOWS_FILE_SHARE_PATH +
  //     "'",
  //     options
  //   );
  // }

  // callProjectUrlAssetFetch(options) {

  //   return this._https.get(
  //     DconConfigAPI.UIPATH_ASSET_FETCH +
  //     "'" +
  //     DconConfigAPI.DFTE_WORKBENCH_ORDS_URL +
  //     "'",
  //     options
  //   );
  // }

  callKeyVaultApi(projectName, assetname) {

    return this._https.get(
      DconConfigAPI.KEYVAULT_API_URL +
      projectName +
      assetname
    );
  }

  callAuthFolderDetails(payload) {
    return this._https.post(
      DconConfigAPI.NODE_URL + "/uipath/uipath-fetch-assets",
      {...payload, assetName:DconConfigAPI.ORDS_URL_ASSET}
    );
  }

  // TODO
  callLegacyExtractStatus(options) {
    console.log('callLegacyExtractStatus', options)
    // return this._https.get(
    //   DconConfigAPI.UI_PATH + DconConfigAPI.URL_PROPS.ODATA_ASSETS_FILTER + projectName + DconConfigAPI.LEGACY_EXTRACT_APPLICABLE_ASSET + "'",
    //   options
    // );
    return this._https.post(
      DconConfigAPI.NODE_URL + "/uipath/uipath-fetch-assets",
      {...options, assetName:DconConfigAPI.LEGACY_EXTRACT_APPLICABLE_ASSET}
    );
  }

  callConfigTemplatesPath(payload) {
    // return this._https.get(
    //   DconConfigAPI.UI_PATH + DconConfigAPI.URL_PROPS.ODATA_ASSETS_FILTER + DconConfigAPI.CONFIG_TEMPLATE_PATH + "'",
    //   options
    // );
    return this._https.post(
      DconConfigAPI.NODE_URL + "/uipath/uipath-fetch-assets",
      {...payload, assetName:DconConfigAPI.CONFIG_TEMPLATE_PATH, projectName: ""}
    );
  }

  callWindowsFIleSharePath(payload) {
    // return this._https.get(
    //   DconConfigAPI.UI_PATH + DconConfigAPI.URL_PROPS.ODATA_ASSETS_FILTER + DconConfigAPI.CONFIGHUB_WINDOWS_FILE_SHARE_PATH + "'",
    //   options
    // );
    return this._https.post(
      DconConfigAPI.NODE_URL + "/uipath/uipath-fetch-assets",
      {...payload, assetName:DconConfigAPI.CONFIGHUB_WINDOWS_FILE_SHARE_PATH, projectName:""}
    );
  }


  getSFTPDetails(payload) {
    // const path = this._https.get(
    //   DconConfigAPI.UI_PATH + DconConfigAPI.URL_PROPS.ODATA_ASSETS_FILTER + projectName + DconConfigAPI.SFTP_PATH + "'",
    //   options
    // );
    const path = this._https.post(
      DconConfigAPI.NODE_URL + "/uipath/uipath-fetch-assets",
      {...payload, assetName:DconConfigAPI.SFTP_PATH}
    );
    
    // const port = this._https.get(
    //   DconConfigAPI.UI_PATH + DconConfigAPI.URL_PROPS.ODATA_ASSETS_FILTER + projectName + DconConfigAPI.SFTP_PORT + "'",
    //   options
    // );
    const port = this._https.post(
      DconConfigAPI.NODE_URL + "/uipath/uipath-fetch-assets",
      {...payload, assetName:DconConfigAPI.SFTP_PORT}
    );
    // const credentials = this._https.get(
    //   DconConfigAPI.UI_PATH + DconConfigAPI.URL_PROPS.ODATA_ASSETS_FILTER + projectName + DconConfigAPI.SFTP_CREDENTIALS + "'",
    //   options
    // );
    const credentials = this._https.post(
      DconConfigAPI.NODE_URL + "/uipath/uipath-fetch-assets",
      {...payload, assetName:DconConfigAPI.SFTP_CREDENTIALS}
    );
    // const host = this._https.get(
    //   DconConfigAPI.UI_PATH + DconConfigAPI.URL_PROPS.ODATA_ASSETS_FILTER + projectName + DconConfigAPI.SFTP_HOST + "'",
    //   options
    // );
    const host = this._https.post(
      DconConfigAPI.NODE_URL + "/uipath/uipath-fetch-assets",
      {...payload, assetName:DconConfigAPI.SFTP_HOST}
    );
    return forkJoin([path, port, credentials, host]);
  }


}
